define('responsive-gameday/views/distributors/viewDistributors/ScoringPlaysDistributor',['require','exports','module','GameDayCore','jquery','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        $ = require("jquery"),
        ViewDistributorClass = require("./ViewDistributorBase"),
        UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../events/DistributionEvents"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

    var Superclass;

    function ScoringPlaysDataPack(game){
        var that = this,
            gameData = game.gameData,
            plays = game.liveData.plays.scoringPlays,
            inningsData = game.liveData.linescore.innings,
            teams = game.gameData.teams,
            homeID = teams.home.teamID.replace('ID','t'),
            awayID = teams.away.teamID.replace('ID','t'),
            play,
            scoring = [],
            inning,
            topBottom = {},
            i=0,
            len=plays.length;

        for(; i<len; i++){
            play = plays[i];

            if(!inning || inning.inning !== play.about.inning){
                topBottom.top=[];
                topBottom.bottom = [];
                inning  = { 
                    inning : play.about.inning,
                    inningWithOrdinal : inningsData[(play.about.inning - 1)].ordinalNum,
                    halves : [{
                        half        : 'top',
                        plays       : topBottom.top,
                        cssTeamID   : awayID
                    },{
                        half        : 'bottom',
                        plays       : topBottom.bottom,
                        cssTeamID   : homeID

                    }]
                }
                scoring.push(inning);
            }
            topBottom[play.about.halfInning].push(play);
        }
        this.scoring = scoring;
        this.teams = teams;
    }

    ScoringPlaysDataPack.prototype.mugshot = function(){
        return resourcePath.get('mugshot',{ pid : this.id});
    };

    ScoringPlaysDataPack.prototype.cssTeamID = function(){
        return this.teamID.replace('ID',T);
    }

    function ScoringPlaysDistributor(evt) {
        this.eventType = evt;
        Superclass.constructor.call(this,evt);

        MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_SCORE_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(ScoringPlaysDistributor).define({
        prepDataForView: function() {
            this.dataPack = new ScoringPlaysDataPack(this.game);
            this.dispatchUpdates();
        }
    });

    Superclass = ScoringPlaysDistributor.superclass;

    return ScoringPlaysDistributor;
});

